import styled from "@emotion/styled";

const getJustifyContent = (align: "left" | "center" | "right") => {
  switch (align) {
    case "left":
      return "flex-start";
    case "right":
      return "flex-end";
    case "center":
    default:
      return "center";
  }
};

export const ControllerWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
`;

export const Controller = styled.div<{ align: "left" | "center" | "right" }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: ${(props) => getJustifyContent(props.align)};
  gap: 15px;
`;

export const PlayButton = styled.button`
  background: none;
  border: none;
  padding: 0px;
  font-size: 32px;
  color: #2f8de4;
`;

export const SeekButton = styled.button`
  background: none;
  border: none;
  padding: 0px;
  font-size: 20px;
  color: #2f8de4;
`;

export const FullscreenButton = styled.button`
  border: none;
  background: none;
  padding: 0px;
  font-size: 20px;
  color: #2f8de4;
  margin-left: 10px;
`;

export const TimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const TimeDisplay = styled.div<{ active: boolean }>`
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => (props.active ? "#2f8de4" : "grey")};
  font-variant-numeric: tabular-nums;
`;
